export default __webpack_public_path__ + "static/media/directory.90ab111e.svg";